﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aUtdanningsValg?: Valg<string>;
    bStudieforberedende?: Valg<string>;
    bYrkesfag?: Valg<string>;
    cAar?: Valg<string>;
    dProgram?: Valg<string>;
    visVilkar: boolean;
    visUtbetaling: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';
export const TOGGLE_UTBETALING = 'TOGGLE_UTBETALING';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export interface ToogleUtbetalingAction {
    type: typeof TOGGLE_UTBETALING;
}
export type ValgStateActionTypes = UpdateValgAction | ToggleVilkarAction | ToogleUtbetalingAction;
